import React from 'react';
import styled from 'styled-components';
import { eonImages } from '../../Theming/images';
import { themeColor } from '../../Theming';

const Container = styled.header<{ $height?: string }>`
  width: 100%;
  height: ${({ $height }) => ($height ? $height : 'auto')};
  background-color: ${themeColor('orange')};
  display: flex;
  flex-direction: column;
  padding-top: 20px;

  & > img {
    width: 100%;
    height: auto;
    margin-bottom: -40px;
  }
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  background-color: ${themeColor('orange')};
`;

interface Props {
  height?: string;
  titleContent?: React.ReactNode;
  image?: React.ImgHTMLAttributes<HTMLImageElement>['src'];
}

const Header: React.FC<Props> = ({
  height = '214px',
  titleContent,
  image = eonImages.eon_header,
}) => {
  return (
    <Container $height={height}>
      <TitleContainer>{titleContent}</TitleContainer>
      <img src={image.default} alt="eon logo" />
    </Container>
  );
};

export default Header;
